import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, useToast } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { updateAppAnaytics } from '../../redux/viewApp/appAnalytics';
import { getAppAnalytics } from '../../redux/viewApp/appAnalytics/selectors';
import { getAppById } from '../../utils/app-builder/fetch-applications';
import { AppDashboard } from './components/app-dashboard.component';

export const AppAnalytics = () => {
  const dispatch = useAppDispatch();
  const [appAnalytics, setAppAnalytics] = useState<any>(useAppSelector(getAppAnalytics));
  const toast = useToast();
  const { appId } = useParams();

  useEffect(() => {
    // fetch application data if not available
    const fetchData = async () => {
      const appData = await getAppById(appId as string);
      if (!appData?.isSuccess) {
        toast({
          title: 'Failed to fetch application',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }

      setAppAnalytics(appData?.application || {});
      console.log('appData', appData);
      dispatch(updateAppAnaytics({ appDetail: appData.application }));
    };

    fetchData();
  }, [appId]);

  return (
    <>
      <Box width="100%" display="flex" justifyContent="center" alignItems="center">
        {appAnalytics.appId ? (
          <AppDashboard />
        ) : (
          <Box width="100%" display="flex" justifyContent="center" alignItems="center">
            Loading Data
          </Box>
        )}
      </Box>
    </>
  );
};
